import { TAffairKind } from "@api/affair.int";
import { TAdminLevel, TGuardKind } from "@api/auth.int";
import { Box, BoxProps, Icon, IconProps, Img, useToken } from "@chakra-ui/react";
import { MyIconCsotores, MyIconDugulas, MyIconEloviz, MyIconKozkut, MyIconVizminoseg } from "components/icons";
import { FaCity } from "react-icons/fa";

export const ADMIN_LEVELS: {
    [key in TAdminLevel]: {
        name: string,
    }} = {
        0 : { name : 'Felhasználó'},
        1 : { name : 'Admin'},
        2 : { name : 'Szuperadmin'},
}
export const ADMIN_LEVELS_ARR = Object.entries(ADMIN_LEVELS).map(([k, o]) => ({ ...o, key: parseInt(k) as TAdminLevel }));

export const AFFAIR_KINDS: {
    [key in TAffairKind]: {
        name: string,
        name2: string,
        color: string,
        colorDark: string,
        icon: (props: IconProps) => JSX.Element,
    }
} = {
    'vizminoseg': { color: '#197ea7', colorDark: '#195275', icon: MyIconVizminoseg, name: 'Vízminőség probléma', name2: 'Vízminőség problémát' },
    'csotores': { color: '#48ada9', colorDark: '#3f8986', icon: MyIconCsotores, name: 'Csőtörés', name2: 'Csőtörést' }, //#a84db3 // orig: #bd5459
    //'kozkut': { color: '#6a68c7', colorDark: '#4e4da3', icon: MyIconKozkut, name: 'Közkút meghibásodás', name2: 'Közkút meghibásodást' },
    'kozkut': { color: '#b7ab20', colorDark: '#8f861a', icon: MyIconKozkut, name: 'Közkút meghibásodás', name2: 'Közkút meghibásodást' },
    'dugulas': { color: '#6ba758', colorDark: '#577d41', icon: MyIconDugulas, name: 'Dugulás', name2: 'Dugulást' },
    'eloviz': { color: '#00a775', colorDark: '#127759', icon: MyIconEloviz, name: 'Élővíz szennyezés', name2: 'Élővíz szennyezést' },
}
// --chakra-colors-chakra-body-bg: #0b273f
// secondary-main: #5dc0a1
export const AFFAIR_KINDS_ARR = Object.entries(AFFAIR_KINDS).map(([k, o]) => ({ ...o, key: k as TAffairKind }));

export const GUARD_KINDS: {
    [key in TGuardKind]: {
        name: string,
        src: string,
    }
} = {
    '00': { name: 'Felhasználó', src: '/icons/guard_user.svg' },
    '10': { name: 'Vízibolha', src: '/icons/guard_vizibolha.svg' },
    '20': { name: 'Vízőr', src: '/icons/guard_vizor.svg' },
    '25': { name: 'Vizedes', src: '/icons/guard_vizedes.svg' },
    '30': { name: 'Vízőrmester', src: '/icons/guard_vizormester.svg' },
}
export const GUARD_KINDS_ARR = Object.entries(GUARD_KINDS).map(([k, o]) => ({ ...o, key: k as TGuardKind })).sort((a, b) => parseInt(a.key) - parseInt(b.key));


export const HEADER_TITLE_HEIGHT = 64;
export const NEW_LOCATION_ZOOM = 16;
export const NEW_LOCATION_IN_CITY_ZOOM = 13;

export const BOX_TRAN = '.25s ease-out';

export function useVVColors() {
    const [primary] = useToken('colors', ['primary.main']);
    const bg = 'var(--chakra-colors-cardbg-main)';
    return {
        borderColor: primary, primary, bg
    }

}






export interface VVCardContainerProps extends BoxProps {
}
export function VVCardContainer({ ...rest }: VVCardContainerProps) {
    return <Box
        className="vv-card-container"
        border='1px solid red'


        display='flex' flexDir='column' overflow='hidden'
        alignItems='stretch' justifyContent='flex-start'
        gap={2} p={3}

        {...rest}
    />
}


// ------------------------------------------------------ BOGYO --------------------------------
export interface BogyoProps extends BoxProps {
    kind: TAffairKind;
    variant?: 'dark' | 'light' | 'shadow' | 'number';
    count?: number;
}


export function Bogyo({ kind, variant = 'dark', count, ...rest }: BogyoProps) {
    let Img = AFFAIR_KINDS[kind].icon;


    return <Box
        borderRadius='50%'
        {...variant === 'dark' && { bg: AFFAIR_KINDS[kind].colorDark }}
        {...variant === 'light' && { bg: AFFAIR_KINDS[kind].color }}
        {...variant === 'shadow' && { bg: '#0003' }}
        {...variant === 'number' && { bg: AFFAIR_KINDS[kind].color + '99' }}
        width='40px' height='40px'
        display='flex' alignItems='center' justifyContent='center'
        {...rest}
        position='relative'
    ><Img
            color='#fff'
            {...variant === 'number' && { color: '#0007' }}
            width='24px' />

        {((count || 0) > 0) && <Box position='absolute' color='#fff' left={0} right={0} top={0} bottom={0}
            display='flex' alignItems='flex-end' mb='-6px' justifyContent='center'
            fontWeight='700'
        ><Box borderRadius='md'
            bg={AFFAIR_KINDS[kind].color} px={1}
        >{count}
            </Box>
        </Box>}
    </Box>
}

export function BogyoNumber({ kind, count, ...rest }: BogyoProps) {
    let Img = AFFAIR_KINDS[kind].icon;


    return <Box
        borderRadius='50%'
        bg={AFFAIR_KINDS[kind].color + '99'}
        width='40px' height='40px'
        display='flex' alignItems='center' justifyContent='center'
        {...rest}
        position='relative'
    ><Img
            color='#aaa'
            width='24px' />

        {((count || 0) > 0) && <Box position='absolute' color='#fff' right={0} bottom='-5px'
            bg={AFFAIR_KINDS[kind].color} px={1}
            fontWeight='700' borderRadius='md'
        >{count}
        </Box>}
    </Box>
}


export function Bogyo2({ kind, ...rest }: BogyoProps) {
    let Img = AFFAIR_KINDS[kind].icon;
    return <Img
        //color={AFFAIR_KINDS[kind].color}
        color='#0008'
        width='27px' mr={2}
    />

}



// ------------------------------------------------------ BOGYO --------------------------------
export interface BogyoGuardProps extends BoxProps {
    guardKind: TGuardKind;
}


export function BogyoGuard({ guardKind, ...rest }: BogyoGuardProps) {
    const KIND = GUARD_KINDS[guardKind];
    return <Box
        borderRadius='8px'
        width='40px' height='40px'
        display='flex' alignItems='center' justifyContent='center'
        bg='linear-gradient(360deg, #ffffffc7, #1289b952)'
        overflow='hidden'

        {...rest}

    ><Img src={KIND.src}

        width='45px'
        position='relative'
        left='0px'
        top='7px'
        {...guardKind == '00' && { left: '-4px', top: '4px' }}

        />
    </Box>
}

export function BogyoGroup() {

    return <Box
        borderRadius='50%'
        width='40px' height='40px'
        display='flex' alignItems='center' justifyContent='center'
        bg='linear-gradient(360deg, #ffffffc7, #1289b952)'
        overflow='hidden'
    ><Icon as={FaCity} fontSize='xx-large' color='#fff'

        position='relative'
        left='0px'
        top='7px'


        />
    </Box>
}
